import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/reel/winpresentation/SimplePresentationRunner";
import {DumpsterFire} from "../DumpsterFire";
import {TimelineLite} from "gsap";
import {DumpsterFireSymbol, SYMBOL_NAME} from "../reels/DumpsterFireSymbol";
import {ISymbol} from "../../core/reel/simplereel/IReelData";
import {DumpsterFireSound} from "../sound/DumpsterFireSound";

export class XWaysRunner implements SimplePresentation {
    private _tl: TimelineLite;

    shouldRun(): boolean {
        return DumpsterFire.model.explodeXWPos.length > 0;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._tl = new TimelineLite({
            delay: 0.001,
            onStart: () => {
                this._tl.add(DumpsterFire.reelAnticipation.hideContainer(), 0);
            },
            onComplete: () => {
                DumpsterFire.model.isNotNoWinRound = true;
                if (DumpsterFire.model.data.scatterWins.length === 0 && !DumpsterFire.model.isXBombPresent && DumpsterFire.model.explodeXIPos.length === 0) {
                    DumpsterFire.allReelsView.removeWinMulti();
                    DumpsterFire.winMultiView.removeAllSprites();
                }
                this._tl.kill();
                controller.finish();
            }
        });
        this._tl.add(() => {
            controller.setSkipCallback(() => this.onSkip());
        }, 0.001);
        const explodePositions: number[] = DumpsterFire.model.explodeXWPos;
        const innerTl: TimelineLite = new TimelineLite();
        let isPlayed: boolean = false;
        let largestValue: number = 2;
        for (let i: number = 0; i < explodePositions.length; i++) {
            const reelId: number = Math.floor(explodePositions[i] / 6),
                rowId: number = explodePositions[i] % 6,
                symbol: ISymbol = DumpsterFire.allReelsView.getSymbolAtPosition(reelId, rowId);
            const toSymbol: string = DumpsterFire.model.gameData.evaluatedReels[reelId][rowId];
            let multiValue: number = DumpsterFire.model.data.xWaysMultipliers[reelId][rowId];
            let prevMultiPosValue: number = DumpsterFire.preMultiPosArray[reelId][rowId];
            if (DumpsterFire.model.data.reels[reelId][rowId] === SYMBOL_NAME.X_WAYS) {
                if (multiValue * prevMultiPosValue > largestValue) {
                    largestValue = multiValue * prevMultiPosValue
                }
                innerTl.add([() => {
                    if (!isPlayed) {
                        DumpsterFire.soundPlayer.playSound(DumpsterFireSound.X_WAYS_REVEAL)
                        isPlayed = true;
                    }
                },
                    DumpsterFire.xWaysView.playXWaysAnimation(reelId, rowId)], 0);
                innerTl.add([(<DumpsterFireSymbol>symbol).changeSymbol(toSymbol as SYMBOL_NAME),
                    DumpsterFire.allReelsView.showWinMultipliers(reelId, rowId, multiValue * prevMultiPosValue),
                    DumpsterFire.bgMulti.showMultipliers(reelId, rowId, multiValue * prevMultiPosValue),
                    DumpsterFire.bgFinalMulti.showFinalMultipliers(reelId, rowId, multiValue * prevMultiPosValue)
                ], 0.2);
            }
        }
        this._tl.add(() => {
            DumpsterFire.soundPlayer.getXFeatureMultiSound(largestValue);
        }, 0);
        this._tl.add(innerTl, 0);
        this._tl.to(this, {duration: 0.001});
    }

    private onSkip(): void {
        this._tl.timeScale(4);
    }
}